import { QueryClient } from 'react-query';
import { Observable, of } from 'rxjs';
import { EmptyResponseEntity } from '~client/model/empty-response-entity';
import { rxTask } from '~common/helper/mobx-tasks';
import { apiClient } from '~web/client';
import { Config } from '~web/config';
import { PROFILE_QUERY_KEY } from '~web/interactor/user-profile/perform-get-profile';
import { stores } from '~web/store';
import { AuthStore } from '~web/store/auth-store';
import { UserPreferencesStore } from '~web/store/user-preferences-store';
import { UserProfileStore } from '~web/store/user-profile/user-profile-store';

export const deauthorize = (queryClient?: QueryClient): void => {
  const authStore = stores.authStore as AuthStore;
  const userProfileStore = stores.userProfileStore as UserProfileStore;
  const userPreferencesStore = stores.userPreferencesStore as UserPreferencesStore;

  queryClient?.removeQueries(`${userProfileStore.id}`);
  queryClient?.removeQueries(PROFILE_QUERY_KEY);
  authStore.logout();
  userPreferencesStore.clear();
  userProfileStore.clear();

  // in debug mode we proxy the API so we use the header for auth to avoid CORS errors
  if (Config.isDebugBuild) {
    apiClient.removeAuthorization();
  }
};

const performLogout = (): Observable<EmptyResponseEntity> => {
  return apiClient.userLoginController.logout$();
};

export const logout = rxTask((skipNetworkCall?: boolean, queryClient?: QueryClient) => {
  // Execute the logout api call if requested. Don't wait for the response to clear the local
  // stores - We should always be clearing that state regardless of whether the server call
  // succeeds.
  if (!skipNetworkCall) {
    performLogout();
  }
  deauthorize(queryClient);
  return of(true);
});



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/interactor/user-login/perform-logout.ts